import React from 'react';
import {useFormikContext} from 'formik';
import {Container, InputField, InputLabel} from './styles';
import {theme} from '../../../styles/darkTheme';
import ErrorMessage from './ErrorMessage';
import {hasKey} from '../../../utils/getters';

interface Props {
  type: string;
  label: string;
  placeholder: string;
  name: string;
  defaultValue: any;
  disabled?: boolean;
  integer?: boolean;
}

const FormField: React.FC<Props> = ({
  type,
  label,
  placeholder,
  name,
  defaultValue,
  disabled = false,
  integer = false,
}) => {
  const {setFieldTouched, handleChange, errors, touched, setFieldValue} = useFormikContext();

  const getError = () => {
    if (hasKey(errors, name)) {
      // @ts-ignore
      return errors[name];
    }
    return null;
  };

  const getTouched = () => {
    if (hasKey(touched, name)) {
      // @ts-ignore
      return touched[name];
    }
    return false;
  };

  return (
    <Container>
      <InputLabel theme={theme}>{label}</InputLabel>
      <InputField
        onBlur={() => setFieldTouched(name)}
        type={type}
        defaultValue={defaultValue}
        onChange={handleChange(name)}
        placeholder={placeholder}
        theme={theme}
        disabled={disabled}
      />
      <ErrorMessage error={getError()} visible={getTouched()} />
    </Container>
  );
};

export default FormField;
